!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, s = {}, i = e.parcelRequire5f74;
  null == i && ((i = function(e) {
    if (e in t) return t[e].exports;
    if (e in s) {
      var i = s[e];
      delete s[e];
      var l = {
        id: e,
        exports: {}
      };
      return t[e] = l, i.call(l.exports, l, l.exports), l.exports;
    }
    var n = new Error("Cannot find module '" + e + "'");
    throw n.code = "MODULE_NOT_FOUND", n;
  }).register = function(e, t) {
    s[e] = t;
  }, e.parcelRequire5f74 = i), (0, i.register)("gjV2B", function(e, t) {
    var s, i, l, n;
    s = e.exports, i = "debounce", l = function() {
      return o;
    }, Object.defineProperty(s, i, {
      get: l,
      set: n,
      enumerable: !0,
      configurable: !0
    });
    const o = (e, t) => {
      let s;
      const i = (...i) => {
        clearTimeout(s), s = setTimeout(() => {
          clearTimeout(s), e(...i);
        }, t);
      };
      return i.cancel = () => {
        clearTimeout(s), s = null;
      }, i;
    };
  });
  var l = i("gjV2B");
  customElements.get("site-header") || customElements.define("site-header", class extends HTMLElement {
    constructor() {
      super(), this.state = {
        isScrolled: !1,
        isSectionStickyLogo: !1,
        currentMenuIndex: null,
        isDesktop: !1,
        isTablet: !1
      }, this.timeouts = {
        menuToggle: null,
        menuClose: null
      }, this.config = {
        toggleDelay: 100,
        closeMenuDelay: 100
      }, this.elements = this.initializeElements(), this.mediaQueries = this.initializeMediaQueries(), 
      this.bindMethods(), this.setupLoadingSpinnerReset(), this.init();
    }
    initializeElements() {
      const e = {
        header: this.closest("header"),
        level0Toggle: this.querySelector("#menu-level0"),
        level0: this.querySelector("nav.header--level0"),
        level1Details: this.querySelectorAll("details.header--level1"),
        level1Toggles: this.querySelectorAll("details.header--level1 summary.header--level1"),
        level2Menus: this.querySelectorAll(".header__level2"),
        headerMegaBackground: this.querySelector(".header-mega__background"),
        actionBarEl: this.querySelector(".header__action-bar"),
        headerLogoContainerEl: this.querySelector(".header__logo-container"),
        logoSmallEl: this.querySelector(".header__logo-small"),
        logoLargeEl: this.querySelector(".header__logo-large"),
        logoStickyEl: this.querySelector(".header__logo-sticky"),
        headerList: this.querySelector(".header-list")
      };
      e.searchLabel = e.actionBarEl?.querySelector('label[for="SearchDrawer"]'), e.cartLabel = e.actionBarEl?.querySelector('label[for="Cart"]');
      const t = document.querySelector("main"), s = Array.from(document.querySelectorAll(".shopify-section")).filter(s => !t.contains(s) && !s.contains(e.level0)), i = Array.from(this.children).filter(t => t !== e.level0 && !t.matches("input") && t !== e.actionBarEl);
      return e.bodyIgnoreElements = [ t, ...s, ...i ], e;
    }
    initializeMediaQueries() {
      return {
        desktop: window.matchMedia("(min-width: 1024px)"),
        tablet: window.matchMedia("(max-width: 1024px)"),
        hover: window.matchMedia("(hover: none)")
      };
    }
    bindMethods() {
      this.handleLevel0Toggle = this.handleLevel0Toggle.bind(this), this.handleLevel1Toggle = this.handleLevel1Toggle.bind(this), 
      this.handleToggleMouseEnter = this.handleToggleMouseEnter.bind(this), this.handleToggleMouseLeave = this.handleToggleMouseLeave.bind(this), 
      this.handleMenuMouseEnter = this.handleMenuMouseEnter.bind(this), this.handleMenuMouseLeave = this.handleMenuMouseLeave.bind(this), 
      this.handleOutsideInteraction = this.handleOutsideInteraction.bind(this), this.debouncedHandleEscape = (0, 
      l.debounce)(this.handleEscape.bind(this), 100), this.handleActionBarClick = this.handleActionBarClick.bind(this), 
      this.handleScrollTrigger = this.handleScrollTrigger.bind(this);
    }
    clearTimeouts() {
      Object.values(this.timeouts).forEach(e => clearTimeout(e)), this.timeouts = {
        menuToggle: null,
        menuClose: null
      };
    }
    toggleBodyOverflow(e) {
      document.body.classList.toggle("overflow-clip", e);
    }
    toggleInertElements(e, t) {
      e.forEach(e => {
        t ? e.setAttribute("inert", "") : e.removeAttribute("inert");
      });
    }
    updateMegaBackgroundHeight(e = null) {
      if (!this.elements.headerMegaBackground) return;
      if (!e) return void (this.elements.headerMegaBackground.style.height = "0px");
      const t = e.closest("header-menu")?.querySelector(".header__level2");
      t && requestAnimationFrame(() => {
        const e = t.offsetHeight;
        this.elements.headerMegaBackground.style.height = `${e}px`;
      });
    }
    handleLevel0Toggle(e) {
      const t = e.target.checked;
      if (this.toggleBodyOverflow(t), this.state.isTablet) {
        if (t) {
          this.elements.level0?.removeAttribute("inert");
          const e = this.elements.level0?.querySelector("a, button, label, summary");
          e?.focus(), this.addOutsideInteractionListeners(), this.elements.headerList && (this.elements.headerList.scrollTop = 0);
          const t = Array.from(this.elements.level1Details).find(e => e.hasAttribute("open"));
          t && t.removeAttribute("open");
        } else this.elements.level0?.setAttribute("inert", ""), this.removeOutsideInteractionListeners();
        this.toggleInertElements(this.elements.bodyIgnoreElements.filter(e => e !== this.elements.level0 && !e.contains(this.elements.level0)), t);
      }
    }
    handleLevel1Toggle(e) {
      "open" === e.newState ? this.openLevel1Menu(e.target) : this.closeLevel1Menu(e.target);
    }
    openLevel1Menu(e) {
      this.elements.level1Details.forEach(t => {
        t !== e && t.hasAttribute("open") && t.removeAttribute("open");
      }), this.state.isTablet || this.toggleBodyOverflow(!0), this.classList.add("menu-open"), 
      this.updateMegaBackgroundHeight(e), this.clearTimeouts(), this.addOutsideInteractionListeners();
    }
    closeLevel1Menu(e) {
      const t = Array.from(this.elements.level1Details).some(t => t !== e && t.hasAttribute("open")), s = document.querySelector("[data-locker]:checked");
      this.state.isTablet || s || this.toggleBodyOverflow(!1), this.classList.remove("menu-open"), 
      t || this.updateMegaBackgroundHeight();
      const i = Array.from(this.elements.level1Details).indexOf(e);
      this.state.currentMenuIndex === i && (this.state.currentMenuIndex = null), t || this.elements.level0Toggle?.checked || this.removeOutsideInteractionListeners();
    }
    handleToggleMouseEnter(e) {
      this.clearTimeouts(), this.timeouts.menuToggle = setTimeout(() => {
        const t = Array.from(this.elements.level1Toggles).indexOf(e.target);
        if (!e.target.parentElement.hasAttribute("open")) {
          const s = this.querySelector("details.header--level1[open]");
          s?.removeAttribute("open"), e.target.click(), this.updateMegaBackgroundHeight(e.target), 
          this.state.currentMenuIndex = t;
        }
      }, this.config.toggleDelay);
    }
    handleToggleMouseLeave() {
      this.clearTimeouts(), this.timeouts.menuClose = setTimeout(() => {
        this.closeCurrentMenu();
      }, this.config.closeMenuDelay);
    }
    handleMenuMouseEnter() {
      this.clearTimeouts();
    }
    handleMenuMouseLeave() {
      this.timeouts.menuClose = setTimeout(() => {
        this.closeCurrentMenu();
      }, this.config.closeMenuDelay);
    }
    addHoverEventListeners() {
      this.elements.level1Toggles.forEach(e => {
        e.addEventListener("mouseenter", this.handleToggleMouseEnter.bind(this), {
          passive: !0
        }), e.addEventListener("mouseleave", this.handleToggleMouseLeave.bind(this), {
          passive: !0
        });
      }), this.elements.level2Menus.forEach(e => {
        e.addEventListener("mouseenter", this.handleMenuMouseEnter.bind(this), {
          passive: !0
        }), e.addEventListener("mouseleave", this.handleMenuMouseLeave.bind(this), {
          passive: !0
        });
      });
    }
    removeHoverEventListeners() {
      this.elements.level1Toggles.forEach(e => {
        e.removeEventListener("mouseenter", this.handleToggleMouseEnter), e.removeEventListener("mouseleave", this.handleToggleMouseLeave);
      }), this.elements.level2Menus.forEach(e => {
        e.removeEventListener("mouseenter", this.handleMenuMouseEnter), e.removeEventListener("mouseleave", this.handleMenuMouseLeave);
      });
    }
    addOutsideInteractionListeners() {
      document.addEventListener("click", this.handleOutsideInteraction, !0), document.addEventListener("focusin", this.handleOutsideInteraction, !0);
    }
    removeOutsideInteractionListeners() {
      document.removeEventListener("click", this.handleOutsideInteraction, !0), document.removeEventListener("focusin", this.handleOutsideInteraction, !0);
    }
    closeCurrentMenu() {
      if (null !== this.state.currentMenuIndex) {
        const e = this.elements.level1Toggles[this.state.currentMenuIndex];
        e?.parentElement.hasAttribute("open") && (e.click(), this.updateMegaBackgroundHeight()), 
        this.state.currentMenuIndex = null;
      }
    }
    handleEscape(e) {
      "Escape" === e.key && (this.elements.level0Toggle?.checked ? this.elements.level0Toggle.click() : this.closeAllLevel1Menus());
    }
    handleOutsideInteraction(e) {
      this.contains(e.target) || [ "[data-locker]", ".search-drawer", ".cart-drawer", "#SearchDrawer", "#Cart" ].some(t => {
        const s = document.querySelector(t);
        return s && s.contains(e.target);
      }) || (this.elements.level0Toggle?.checked && this.elements.level0Toggle.click(), 
      this.closeAllLevel1Menus());
    }
    closeAllLevel1Menus() {
      const e = this.querySelectorAll("details.header--level1[open]");
      e.forEach(t => {
        this.state.isTablet && 1 === e.length || t.removeAttribute("open");
      }), this.state.currentMenuIndex = null, this.classList.remove("menu-open"), this.updateMegaBackgroundHeight();
    }
    handleActionBarClick() {
      this.state.isTablet && this.elements.level0Toggle?.checked && this.elements.level0Toggle.click();
    }
    setupDesktopBehavior() {
      this.state.isDesktop && (this.elements.level0Toggle?.checked && (this.elements.level0Toggle.click(), 
      this.elements.level1Toggles[0]?.click()), this.style.position = null, this.elements.level0?.removeAttribute("inert"), 
      this.setLevelContainerAttributes(!0), document.removeEventListener("keydown", this.debouncedHandleEscape), 
      this.elements.searchLabel?.removeEventListener("click", this.handleActionBarClick), 
      this.elements.cartLabel?.removeEventListener("click", this.handleActionBarClick), 
      this.removeAttribute("data-height"), this.elements.actionBarEl && (this.elements.actionBarEl.style.height = "", 
      this.elements.actionBarEl.removeAttribute("data-action-bar-height")), this.state.isSectionStickyLogo = document.querySelector("main > .shopify-section")?.children[0]?.hasAttribute("sticky-logo-header"), 
      window.addEventListener("scroll-trigger", this.handleScrollTrigger), this.handleStickyLogoDesktop(), 
      this.handleFooterLogoDesktop());
    }
    async handleScrollTrigger(e) {
      this.state.isScrolled = e.detail?.isScrolled, this.state.isSectionStickyLogo && (this.state.isScrolled ? requestAnimationFrame(() => {
        this.elements.logoSmallEl.style.maxWidth = null;
      }) : (await this.waitForCookieBannerHidden(), requestAnimationFrame(() => {
        this.elements.logoStickyEl?.classList.contains("hidden") && this.elements.logoStickyEl.classList.remove("hidden"), 
        getComputedStyle(this.elements.logoSmallEl).getPropertyValue("--maximum-width").trim() && (this.elements.logoSmallEl.style.maxWidth = "0px");
      })));
    }
    setupLoadingSpinnerReset() {
      if (!this.elements.level0Toggle) return;
      const e = () => {
        this.state.isTablet && document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "site-header",
            transform: this.elements.level0Toggle.checked ? "RESET" : ""
          }
        }));
      };
      this.elements.level0Toggle.addEventListener("change", e), this._cleanupSpinnerReset = () => {
        this.elements.level0Toggle.removeEventListener("change", e);
      };
    }
    setupTabletBehavior() {
      this.state.isTablet && (this.querySelectorAll("details").forEach(e => e.removeAttribute("open")), 
      this.elements.level0Toggle?.checked && this.elements.level0Toggle.click(), this.elements.level0?.setAttribute("inert", ""), 
      this.setLevelContainerAttributes(!1), document.addEventListener("keydown", this.debouncedHandleEscape, {
        passive: !0
      }), this.elements.searchLabel?.addEventListener("click", this.handleActionBarClick), 
      this.elements.cartLabel?.addEventListener("click", this.handleActionBarClick), requestAnimationFrame(() => {
        const e = this.offsetHeight;
        this.setAttribute("data-height", `${e}`), this.elements.actionBarEl && (this.elements.actionBarEl.setAttribute("data-action-bar-height", `${e}`), 
        this.elements.actionBarEl.style.height = `${e}px`);
      }));
    }
    setLevelContainerAttributes(e) {
      this.elements.level1Details.forEach(t => {
        const s = `MegaMenu-Content-${t.id.split("-").pop()}`, i = t.parentElement.querySelector(`#${s}`);
        i && (i.setAttribute("aria-hidden", !e), e ? i.removeAttribute("tabindex") : i.setAttribute("tabindex", "-1"));
      });
    }
    waitForCookieBannerHidden() {
      return !0;
    }
    async handleStickyLogoDesktop() {
      this.state.isSectionStickyLogo && (await this.waitForCookieBannerHidden(), window.scrollY < 10 && this.elements.logoStickyEl?.classList.remove("hidden"), 
      setTimeout(() => {
        this.setLogoMaxWidth();
      }, 100), setTimeout(() => {
        window.scrollY < 10 && (this.elements.logoSmallEl.style.maxWidth = "0px"), this.elements.logoStickyEl && (this.elements.logoStickyEl.style.clipPath = "inset(0px)");
      }, 150));
    }
    setLogoMaxWidth() {
      const e = this.elements.logoSmallEl;
      if (!e) return;
      const t = e.style.maxWidth;
      e.style.opacity = 0, e.style.position = "absolute", e.style.maxWidth = "none", e.style.width = "auto", 
      e.style.setProperty("--maximum-width", `${e.offsetWidth}px`), e.style.maxWidth = t, 
      e.style.position = null, e.style.width = null, e.style.opacity = null;
    }
    handleFooterLogoDesktop() {
      document.querySelector("footer .footer__large-logo") && (getComputedStyle(this.elements.logoSmallEl).getPropertyValue("--maximum-width").trim() || this.elements.logoSmallEl.style.setProperty("--maximum-width", `${this.elements.logoSmallEl.offsetWidth}px`), 
      window.addEventListener("footer-logo-display", e => {
        e.detail.visible ? getComputedStyle(this.elements.logoSmallEl).getPropertyValue("--maximum-width").trim() && (this.elements.logoSmallEl.style.maxWidth = "0px") : this.elements.logoSmallEl.style.maxWidth = null;
      }));
    }
    handleMediaQueryChange() {
      const e = this.mediaQueries.desktop.matches;
      e !== this.state.isDesktop && (this.state.isDesktop = e, this.state.isTablet = !e, 
      this.state.isDesktop ? this.setupDesktopBehavior() : this.setupTabletBehavior());
    }
    init() {
      this.state.isDesktop = this.mediaQueries.desktop.matches, this.state.isTablet = this.mediaQueries.tablet.matches, 
      this.elements.level0Toggle?.addEventListener("change", this.handleLevel0Toggle), 
      this.elements.level1Details.forEach(e => {
        e.addEventListener("toggle", this.handleLevel1Toggle);
      }), this.mediaQueries.hover.matches || this.addHoverEventListeners(), this.mediaQueries.hover.addEventListener("change", e => {
        e.matches ? this.removeHoverEventListeners() : this.addHoverEventListeners();
      }), this.mediaQueries.desktop.addEventListener("change", () => this.handleMediaQueryChange());
      const e = this.mediaQueries.desktop.matches;
      this.state.isDesktop = e, this.state.isTablet = !e, e ? this.setupDesktopBehavior() : this.setupTabletBehavior();
    }
  });
}();